import { StaticMediaData } from '@monogrid/vue-boost'

import BbIntroImage from '@/assets/images/intro/bb'
import G25IntroImage from '@/assets/images/intro/g25'
import GoIntroImage from '@/assets/images/intro/go'
import GvIntroImage from '@/assets/images/intro/gv'
import BbImage from '@/assets/images/menu/bb'
import G25Image from '@/assets/images/menu/g25'
import GvImage from '@/assets/images/menu/gg'
import GoImage from '@/assets/images/menu/go2'

export type MenuPrimaryItemOptions = {
  id: number | string
  order: {
    desktop: number
    mobile: number
  }
  label: {
    en: string
    it: string
    fr: string
    ja: string
    zh: string
  },
  externalUrl?: {
    en: string
    it: string
    fr: string
    ja: string
    zh: string
  }
  to?: {
    name: string
    params: {
      pageSlug: string
    }
  },
  workingHours: {
    en: string
    it: string
    fr: string
    ja: string
    zh: string
  },
  address: {
    en: string
    it: string
    fr: string
    ja: string
    zh: string
  },
  intro: {
    top: number
    left: number
    width: number
    height: number
    image: StaticMediaData
  },
  image: StaticMediaData
}

export const primaryItems: MenuPrimaryItemOptions[] = [
  {
    id: 'gucci-galleria',
    order: {
      desktop: 1,
      mobile: 3
    },
    label: {
      en: 'Gucci Galleria',
      it: 'Gucci Galleria',
      fr: 'Gucci Galleria',
      ja: 'グッチ ガレリア',
      zh: 'Gucci Galleria'
    },
    to: {
      name: 'Editorial',
      params: {
        pageSlug: 'gucci-galleria'
      }
    },
    workingHours: {
      en: 'Every day from 10am to 7pm\\\nwith last entry at 6:30pm.',
      it: 'Tutti i giorni dalle ore 10:00 alle 19:00,\\\ncon ultimo ingresso galleria alle ore 18:30.',
      fr: 'Tous les jours de 10 h à 19 h\\\n(dernières entrées à 18 h 30)',
      ja: '10:00am-7:00pm\\\n最終入場6:30pmまで',
      zh: '每日上午10点至晚上7点\\\n（6点30分后停止入场）'
    },
    address: {
      en: 'Piazza della Signoria 10\\\n50122, Florence, Italy\\\nT: [+39 055.75927010](tel:+3905575927010)',
      it: 'Piazza della Signoria 10\\\n50122, Firenze, Italia\\\nT: [+39 055.75927010](tel:+3905575927010)',
      fr: 'Piazza della Signoria 10\\\nFlorence, 50122, Italie\\\nTél: [+39 055.75927010](tel:+3905575927010)',
      ja: 'Piazza della Signoria 10\\\nFlorence, 50122, Italy\\\nTEL: [+39 055.75927010](tel:+3905575927010)',
      zh: '意大利佛罗伦萨市政广场10号\\\n邮编50122\\\n电话：[+39 055.75927010](tel:+3905575927010)'
    },
    intro: {
      top: 32,
      left: 48,
      width: 46,
      height: 25,
      image: GvIntroImage
    },
    image: GvImage
  },
  {
    id: 'boutique-bookstore',
    order: {
      desktop: 2,
      mobile: 4
    },
    label: {
      en: 'The Boutique and Bookstore',
      it: 'La Boutique e il Bookstore',
      fr: 'La boutique et la librairie',
      ja: 'ショップ＆ブックストア',
      zh: '精品店及书店'
    },
    to: {
      name: 'Editorial',
      params: {
        pageSlug: 'boutique-bookstore'
      }
    },
    workingHours: {
      en: 'Every day from 10am to 7pm',
      it: 'Tutti i giorni dalle ore 10:00 alle 19:00',
      fr: 'Tous les jours de 10h à 19h',
      ja: '10:00am-7:00pm',
      zh: '每日上午10点至晚上7点'
    },
    address: {
      en: 'Piazza della Signoria 10\\\n50122, Florence, Italy\\\nT: [+39 055.75927010](tel:+3905575927010)',
      it: 'Piazza della Signoria 10\\\n50122, Firenze, Italia\\\nT: [+39 055.75927010](tel:+3905575927010)',
      fr: 'Piazza della Signoria 10\\\nFlorence, 50122, Italie\\\nTél: [+39 055.75927010](tel:+3905575927010)',
      ja: 'Piazza della Signoria 10\\\nFlorence, 50122, Italy\\\nTEL: [+39 055.75927010](tel:+3905575927010)',
      zh: '意大利佛罗伦萨市政广场10号\\\n邮编50122\\\n电话：[+39 055.75927010](tel:+3905575927010)'
    },
    intro: {
      top: 58,
      left: 52,
      width: 42,
      height: 28,
      image: BbIntroImage
    },
    image: BbImage
  },
  {
    id: 'giardino-25',
    order: {
      desktop: 5,
      mobile: 1
    },
    label: {
      en: 'Gucci Giardino',
      it: 'Gucci Giardino',
      fr: 'Gucci Giardino',
      ja: 'グッチ ジャルディーノ',
      zh: 'Gucci Giardino'
    },
    externalUrl: {
      en: 'https://www.gucciosteria.com/en/florence/giardino',
      it: 'https://www.gucciosteria.com/it/florence/giardino',
      fr: 'https://www.gucciosteria.com/en/florence/giardino',
      ja: 'https://www.gucciosteria.com/en/florence/giardino',
      zh: 'https://www.gucciosteria.com/en/florence/giardino'
    },
    workingHours: {
      en: 'Closing days: January 1st, August 15th, December 25th.\\\n\\\nOn February 11th the bar will open at 11:00 AM\\\n\\\nMonday to Sunday: 10am – 12am\\\nBreakfast: 10am – 3pm\\\nLight Lunch: 10am – 4pm\\\nLight Dinner: 6pm – 9pm\\\nAfternoon Tea: 3pm – 6pm\\\nAperitif & Cocktails: 6pm - 12am\\\nCocktails are served from 12pm - 12am',
      it: 'Giorni di chiusura: 1° gennaio, 15 agosto, 25 dicembre.\\\n\\\nIn data 11 febbraio il bar aprirà alle 11:00\\\n\\\nDal lunedì alla domenica: 10:00 – 00:00\\\nColazione: 10:00 – 15:00\\\nPranzo: 10:00 – 16:00\\\nCena: 18:00 – 21:00\\\nTè del pomeriggio: 15:00 – 18:00\\\nAperitivo e cocktail: 18:00 – 00:00\\\nI cocktail vengono serviti dalle 12:00 - 00:00',
      fr: 'Closing days: January 1st, August 15th, December 25th.\\\n\\\nOn February 11th the bar will open at 11:00 AM\\\n\\\nDu lundi au dimanche: 10h – 0h\\\nPetit-déjeuner: 10h – 16h\\\nDéjeuner/Dîner: 18 h – 21 h\\\nThé: 15 h – 18 h\\\nApéritif et cocktails: 18 h – 0 h\\\nLes cocktails sont servis de 12 h à 0 h',
      ja: 'Closing days: January 1st, August 15th, December 25th.\\\n\\\nOn February 11th the bar will open at 11:00 AM\\\n\\\n月曜日-日曜日 10:00-00:00\\\n朝食 10:00-16:00\\\nブランチ 18:00-21:00\\\nアフタヌーンティー 15:00-18:00\\\nアペリティフ＆カクテル 18:00-0:00\\\nカクテルは12:00-00:00まで',
      zh: 'Closing days: January 1st, August 15th, December 25th.\\\n\\\nOn February 11th the bar will open at 11:00 AM\\\n\\\n周一至周日：上午10点至次日凌晨0点\\\n早餐：上午10点至16点\\\n简易午餐：上午18点至下午21点\\\n下午茶：下午3点至6点\\\n餐前酒和鸡尾酒：下午6点至次日凌晨0点\\\n鸡尾酒在中午12点至次日凌晨0点供应'
    },
    address: {
      en: 'Piazza della Signoria 37r, Florence, 50122, Italy\\\nT: [+39 055 75927012](tel:+3905575927012)\\\nM. [giardino@gucci.com](giardino@gucci.com)',
      it: 'Piazza della Signoria 37r, Firenze, 50122, Italia\\\nT: [+39 055 75927012](tel:+3905575927012)\\\nM. [giardino@gucci.com](giardino@gucci.com)',
      fr: 'Piazza della Signoria 37r, Florence, 50122, Italie\\\nT: [+39 055 75927012](tel:+3905575927012)\\\nM. [giardino@gucci.com](giardino@gucci.com)',
      ja: 'Piazza della Signoria 37r, Florence, 50122, Italy\\\nT: [+39 055 75927012](tel:+3905575927012)\\\nM. [giardino@gucci.com](giardino@gucci.com)',
      zh: '意大利佛罗伦萨市政广场37r号，邮编50122\\\n电话： [+39 055 75927012](tel:+3905575927012)\\\nM. [giardino@gucci.com](giardino@gucci.com)'
    },
    intro: {
      top: 62,
      left: 0,
      width: 26,
      height: 22,
      image: G25IntroImage
    },
    image: G25Image
  },
  {
    id: 'gucci-osteria',
    order: {
      desktop: 5,
      mobile: 1
    },
    label: {
      en: 'Gucci Osteria',
      it: 'Gucci Osteria',
      fr: 'Gucci Osteria',
      ja: 'グッチ オステリア',
      zh: 'Gucci Osteria'
    },
    externalUrl: {
      en: 'https://www.gucciosteria.com/en',
      it: 'https://www.gucciosteria.com/it',
      fr: 'https://www.gucciosteria.com/en',
      ja: 'https://www.gucciosteria.com/en',
      zh: 'https://www.gucciosteria.com/en'
    },
    workingHours: {
      en: 'Gucci Osteria will be closed on December 25th and January 1st.',
      it: 'Gucci Osteria rimarrà chiusa il 25 dicembre e il 1° gennaio.',
      fr: 'Gucci Osteria will be closed on December 25th and January 1st.',
      ja: 'Gucci Osteria will be closed on December 25th and January 1st.',
      zh: 'Gucci Osteria will be closed on December 25th and January 1st.'
    },
    address: {
      en: 'Piazza della Signoria 10, Florence, 50122, Italy\\\nT: [+39 055 0621744](tel:+390550621744)\\\nM. [gucciosteria.mb@gucci.com](gucciosteria.mb@gucci.com)',
      it: 'Piazza della Signoria 10, Firenze, 50122, Italia\\\nT: [+39 055 0621744](tel:+390550621744)\\\nM. [gucciosteria.mb@gucci.com](gucciosteria.mb@gucci.com)',
      fr: 'Piazza della Signoria 10, Florence, 50122, Italie\\\nT: [+39 055 0621744](tel:+390550621744)\\\nM. [gucciosteria.mb@gucci.com](gucciosteria.mb@gucci.com)',
      ja: 'Piazza della Signoria 10, Florence, 50122, Italy\\\nT: [+39 055 0621744](tel:+390550621744)\\\nM. [gucciosteria.mb@gucci.com](gucciosteria.mb@gucci.com)',
      zh: '大利佛罗伦萨市政广场10号，邮编50122\\\n电话： [+39 055 0621744](tel:+390550621744)\\\nM. [gucciosteria.mb@gucci.com](gucciosteria.mb@gucci.com)'
    },
    intro: {
      top: 58,
      left: 40,
      width: 12,
      height: 17,
      image: GoIntroImage
    },
    image: GoImage
  }
]

export const secondaryItems = [
  {
    id: 1,
    externalUrl: {
      en: 'https://www.gucciosteria.com/en/florence/menu/',
      it: 'https://www.gucciosteria.com/it/florence/menu/'
    },
    label: {
      en: 'Discover the Gucci Osteria Florence Menu',
      it: 'Scopri il Menu di Gucci Osteria Firenze',
      fr: 'Découvrez le menu de Gucci Osteria Florence',
      ja: 'グッチ オステリア フィレンツェのメニューを見る',
      zh: '探索佛罗伦萨Gucci Osteria餐厅菜单'
    }
  }
]
